import React from 'react';

import { NEFI_ERROR } from 'components/NEFIForm/Utils/NEFIError';

import {
  MainNE,
  VALIDATION_CONDITIONS,
  always,
  isGermanyCountry,
  isLokaRefEnabled,
  isRegisteringInstallerEnergyGuest,
  isRegisteringInstallerGasGuest,
  mobileOrPhoneOptional,
  never,
  onlyAVA,
  onlyBAG,
  onlyGuestNE,
  onlyHilfsbetrieb,
} from 'global/renderingValidationConstants';

export const NEFI_ANREDE_OPTIONS = [
  { label: 'Herr', value: 'Herr' },
  { label: 'Frau', value: 'Frau' },
  { label: 'Firma', value: 'Firma' },
];

export const NEFI_FIRST_SECTION_INPUTS = [
  {
    id: 'companyNames',
    title: 'Firmendaten',
    whenShouldSectionRender: always,
    infoText:
      'Hier können Sie Ihre Registrierung als Fachinteressent beantragen. Beim Verlassen der Seite werden Ihre Daten nicht gespeichert.',
    fields: [
      {
        name: 'companyName1',
        fieldName: 'Firmenname / Name',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyName2',
        fieldName: 'Firmenname (weitere Angaben)',
        whenShouldFieldRender: always,
      },
      {
        name: 'companyName3',
        fieldName: 'Firmenname (weitere Angaben)',
        whenShouldFieldRender: always,
      },
      {
        name: 'b_anrede_id',
        fieldName: 'Anrede',
        type: 'select',
        items: NEFI_ANREDE_OPTIONS,
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'taetigkeitsschwerpunkt',
        fieldName: 'Tätigkeitsschwerpunkt',
        type: 'comboBox',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyOwner',
        fieldName: 'Ansprechpartner',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: onlyBAG,
        },
        whenShouldFieldRender: onlyBAG,
      },
    ],
  },
  {
    id: 'companyAddress',
    whenShouldSectionRender: isLokaRefEnabled,
    fields: [
      {
        name: 'companyCountry',
        fieldName: 'Land',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyPostal',
        fieldName: 'PLZ',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyPostalCity',
        fieldName: 'PLZ_Ort_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyCity',
        fieldName: 'Ort',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegion',
        fieldName: 'Ortsteil',
        whenShouldFieldRender: always,
      },
      {
        name: 'companyStreetId',
        fieldName: 'Straße_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyStreet',
        fieldName: 'Straße',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegionId',
        fieldName: 'Ortsteil_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyHouseNumber',
        fieldName: 'Hausnummer',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyHouseNumberAddition',
        fieldName: 'Hausnummerzusatz',
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyStreetData',
    whenShouldSectionRender: {
      type: VALIDATION_CONDITIONS.NOT,
      condition: isLokaRefEnabled,
    },
    fields: [
      {
        name: 'companyCountry',
        fieldName: 'Land',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyStreet',
        fieldName: 'Straße',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyHouseNumber',
        fieldName: 'Hausnummer',
        optional: never,
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyCity',
    whenShouldSectionRender: {
      type: VALIDATION_CONDITIONS.NOT,
      condition: isLokaRefEnabled,
    },
    fields: [
      {
        name: 'companyPostal',
        fieldName: 'PLZ',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyCity',
        fieldName: 'Ort',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegion',
        fieldName: 'Ortsteil',
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'avaExtraInfo',
    subtitle: 'Zuweisung Auftragsort',
    tooltip: (
      <div className="deb-form__ava-tooltip-table">
        <div>
          Diese Angabe benötigen wir für unsere interne Zuordnung. Sofern Sie die Anmeldung von
          mehreren Installationsanlagen in unserem Gebiet planen, geben Sie die PLZ eines beliebigen
          Auftragsortes an. Ihre Gasteintragung gilt für das gesamte Gebiet der Avacon Netz GmbH. In
          der Tabelle einige Beispiele
        </div>
        <table cellPadding="0" cellSpacing="0" border="0">
          <thead>
            <tr>
              <th>Standort</th>
              <th>PLZ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Burgwedel</td>
              <td>30938</td>
            </tr>
            <tr>
              <td>Gardelegen</td>
              <td>39638</td>
            </tr>
            <tr>
              <td>Gehrden</td>
              <td>30989</td>
            </tr>
            <tr>
              <td>Lüneburg</td>
              <td>21337</td>
            </tr>
            <tr>
              <td>Salzwedel</td>
              <td>29410</td>
            </tr>
            <tr>
              <td>Sarstedt</td>
              <td>31157</td>
            </tr>
            <tr>
              <td>Schöningen</td>
              <td>38364</td>
            </tr>
            <tr>
              <td>Syke</td>
              <td>28857</td>
            </tr>
            <tr>
              <td>Oschersleben</td>
              <td>39387</td>
            </tr>
            <tr>
              <td>WEVG / Salzgitter</td>
              <td>38226</td>
            </tr>
          </tbody>
        </table>
      </div>
    ),
    whenShouldSectionRender: never,
    fields: [
      {
        name: 'avaGuestPostal',
        fieldName: 'PLZ Auftragsort',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [onlyAVA, onlyGuestNE],
          },
        },
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyGuestNE, onlyAVA],
        },
      },
    ],
  },
  {
    id: 'companyContacts',
    subtitle: 'Kontaktdaten',
    whenShouldSectionRender: always,
    fields: [
      {
        name: 'mobile',
        fieldName: 'Mobil',
        infoText: 'Entweder Mobil und/oder Telefonnummer angeben',
        optional: mobileOrPhoneOptional('mobile'),
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyContacts2',
    whenShouldSectionRender: always,
    fields: [
      {
        name: 'phone',
        fieldName: 'Telefon',
        optional: mobileOrPhoneOptional('phone'),
        whenShouldFieldRender: always,
      },
      {
        name: 'email',
        fieldName: 'E-Mail-Adresse',
        readOnly: true,
        infoText: '(Entspricht der im ersten Schritt von Ihnen eingetragenen Adresse)',
        optional: never,
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'craftChamberData',
    subtitle: 'Eintragung bei der Handwerkskammer',
    tooltip: 'Handwerkskarte',
    whenShouldSectionRender: never,
    fields: [
      {
        name: 'craftsChamberArea',
        type: 'comboBox',
        fieldName: 'Ausgestellt von',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [
            onlyBAG,
            {
              type: VALIDATION_CONDITIONS.NOT,
              condition: onlyHilfsbetrieb,
            },
            MainNE,
          ],
        },
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [
              onlyBAG,
              {
                type: VALIDATION_CONDITIONS.NOT,
                condition: onlyHilfsbetrieb,
              },
              MainNE,
            ],
          },
        },
      },
      {
        name: 'craftsChamberNumber',
        fieldName: 'Betriebsnummer',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [
            onlyBAG,
            {
              type: VALIDATION_CONDITIONS.NOT,
              condition: onlyHilfsbetrieb,
            },
            MainNE,
          ],
        },
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [
              onlyBAG,
              {
                type: VALIDATION_CONDITIONS.NOT,
                condition: onlyHilfsbetrieb,
              },
              MainNE,
            ],
          },
        },
      },
      {
        name: 'craftsChamberDate',
        fieldName: 'Ausstellungsdatum',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [
            onlyBAG,
            {
              type: VALIDATION_CONDITIONS.NOT,
              condition: onlyHilfsbetrieb,
            },
            MainNE,
          ],
        },
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [
              onlyBAG,
              {
                type: VALIDATION_CONDITIONS.NOT,
                condition: onlyHilfsbetrieb,
              },
              MainNE,
            ],
          },
        },
      },
    ],
  },
  {
    id: 'businessRegistrationData',
    subtitle: 'Gewerbean-/ummeldung',
    tooltip: 'von der zuständigen Gemeinde/Stadt',
    whenShouldSectionRender: never,
    fields: [
      {
        name: 'businessRegistrationLocation',
        fieldName: 'Ort',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [
              onlyBAG,
              {
                type: VALIDATION_CONDITIONS.NOT,
                condition: onlyHilfsbetrieb,
              },
              MainNE,
            ],
          },
        },
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyBAG, MainNE],
        },
      },
      {
        name: 'businessRegistrationDate',
        fieldName: 'Ausstellungsdatum',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: {
            type: VALIDATION_CONDITIONS.AND,
            conditions: [
              onlyBAG,
              {
                type: VALIDATION_CONDITIONS.NOT,
                condition: onlyHilfsbetrieb,
              },
              MainNE,
            ],
          },
        },
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyBAG, MainNE],
        },
      },
    ],
  },
  {
    id: 'commercialRegistrationData',
    subtitle: 'Handelsregisterauszug',
    tooltip:
      'mit Nennung der aktuellen Inhaber/Geschäftsführer (bei Firmierung als „e. K.“, „GmbH“, „GmbH & Co. KG“; „AG“, etc.)',
    whenShouldSectionRender: never,

    fields: [
      {
        name: 'commercialRegisterNumber',
        fieldName: 'HRA/-B-Nummer',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyBAG, MainNE],
        },
        optional: always,
      },
      {
        name: 'commercialRegisterLocation',
        fieldName: 'Amtsgericht',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyBAG, MainNE],
        },
        optional: always,
      },
      {
        name: 'commercialRegisterDate',
        fieldName: 'Auszug vom',
        whenShouldFieldRender: {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [onlyBAG, MainNE],
        },
        optional: always,
      },
    ],
  },
  {
    id: 'gridProviderTitle',
    title: 'Gasteintragung',
    infoText:
      'Die Eintragungsdaten zu Firma und Fachkraft müssen den Daten auf Ihrem Installateurausweis entsprechen. Bitte aktualisieren Sie den Ausweis vor der Eintragung, falls erforderlich. Abweichende Daten können nicht eingetragen werden.',
    fields: [],
    whenShouldSectionRender: never,
  },
  {
    id: 'gridEnergyProvider',
    subtitle: 'Eintragung bei ortsansässigem Netzbetreiber Strom',
    whenShouldSectionRender: never,
    fields: [
      {
        name: 'gridProviderEnergy',
        fieldName: 'Netzbetreiber',
        type: 'comboBox',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: isRegisteringInstallerEnergyGuest,
        },
        whenShouldFieldRender: isRegisteringInstallerEnergyGuest,
      },
      {
        name: 'foreignCompanyIdEnergy',
        fieldName: 'Ausweis-Nummer',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: isRegisteringInstallerEnergyGuest,
        },
        whenShouldFieldRender: isRegisteringInstallerEnergyGuest,
      },
    ],
  },
  {
    id: 'gridGasProvider',
    subtitle: 'Eintragung bei ortsansässigem Netzbetreiber Gas',
    whenShouldSectionRender: never,

    fields: [
      {
        name: 'gridProviderGas',
        fieldName: 'Netzbetreiber',
        type: 'comboBox',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: isRegisteringInstallerGasGuest,
        },

        whenShouldFieldRender: isRegisteringInstallerGasGuest,
      },
      {
        name: 'foreignCompanyIdGas',
        fieldName: 'Ausweis-Nummer',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: isRegisteringInstallerGasGuest,
        },

        whenShouldFieldRender: isRegisteringInstallerGasGuest,
      },
    ],
  },
];

export const checkErrors = (values, branchSelectionValues, formErrors) => {
  const errors = [];

  if (Object.keys(formErrors).length !== 0) {
    errors.push(NEFI_ERROR.FORM_FIELD);
  }

  if (values.experts.length === 0) {
    errors.push(NEFI_ERROR.MIN_EXPERT);
  }

  if (branchSelectionValues.isEnergyActive && branchSelectionValues.isGasActive) {
    const hasEnergyExpert = values.experts.some((expert) => expert.isExpertEnergyActive);
    const hasGasExpert = values.experts.some((expert) => expert.isExpertGasActive);
    if (!hasEnergyExpert || !hasGasExpert) {
      errors.push(NEFI_ERROR.MIN_BRANCH_EXPERT);
    }
  }

  return errors;
};
